import DailyLoadsRequests from '../../server/dailyLoads';
import { addLoading, removeLoading } from './loading';

export const setDailyLoads = (dailyLoads) => ({
  type: 'SET_DAILY_SHIPMENTS',
  dailyLoads,
});

export const setSelectedDailyLoads = (selectedDailyLoads) => async (dispatch) => {
  dispatch(setDailyLoads(selectedDailyLoads));
};

export const getDailyLoadsList = (tableParams = {}) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const dailyLoads = await DailyLoadsRequests.getDailyLoads(tableParams);
    dispatch(setDailyLoads(dailyLoads ? dailyLoads.rows : []));
    dispatch(removeLoading());
    return dailyLoads || 0;
  } catch (e) {
    dispatch(removeLoading());
    return 0;
  }
};

export const getDailyLoadDashboardData = (tableParams = {}) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const dailyLoadDashboardData = await DailyLoadsRequests.getDailyLoadDashboardData(tableParams);
    return dailyLoadDashboardData;
  } finally {
    dispatch(removeLoading());
  }
};

export const createDailyLoad = (dailyLoad) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const newDailyLoad = await DailyLoadsRequests.createDailyLoad(dailyLoad);
    return newDailyLoad;
  } finally {
    dispatch(removeLoading());
  }
};

export const updateDailyLoad = (dailyLoad) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await DailyLoadsRequests.updateDailyLoad(dailyLoad);
  } finally {
    dispatch(removeLoading());
  }
};

export const getDailyLoad = (dailyLoadId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await DailyLoadsRequests.getDailyLoad(dailyLoadId);
  } finally {
    dispatch(removeLoading());
  }
};

export const deleteDailyLoad = (dailyLoadId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await DailyLoadsRequests.deleteDailyLoad(dailyLoadId);
  } finally {
    dispatch(removeLoading());
  }
};
